import type { components } from '../../infra/broker.openapi';
import { BrokerJob, BrokerJobDetails, BrokerJobStatus, BrokerService } from '../core';

type JobSummary = components['schemas']['JobSummary'];
type JobSearchStatus = components['schemas']['JobSearchStatus'];
type JobStatusResponse = components['schemas']['JobStatusResponse'];

const SEARCH_STATUS_TO_BROKER_JOB_STATUS: Record<JobSearchStatus, BrokerJobStatus> = {
	RUNNING: 'RUNNING',
	SUCCEEDED: 'SUCCEEDED',
	FAILED: 'FAILED',
	CANCELLED: 'CANCELLED',
};

export const BrokerJobAdapter = {
	adapt(job: JobSummary, servicesByUuid: Map<string, BrokerService>): BrokerJob {
		const service = job.serviceUUID ? servicesByUuid.get(job.serviceUUID) : undefined;

		return {
			jobId: job.jobId,
			serviceUUID: job.serviceUUID ?? '',
			serviceName: service?.serviceName ?? job.serviceName ?? job.jobId,
			serviceIcon: service?.serviceIcon ?? '',
			status: SEARCH_STATUS_TO_BROKER_JOB_STATUS[job.status],
			startedAt: job.startedAt,
			closedAt: job.closedAt ?? null,
			triggeredBy: job.triggeredBy ?? 'System',
			triggeredByDisplayName: job.triggeredByDisplayName ?? 'System',
			serviceVersion: job.serviceVersion ?? '',
			active: service?.active ?? true,
			error: job.error,
			output: job.output ?? undefined,
		};
	},

	adaptArray(jobs: JobSummary[], servicesByUuid: Map<string, BrokerService>): BrokerJob[] {
		return jobs.map((job) => BrokerJobAdapter.adapt(job, servicesByUuid));
	},

	adaptDetails(job: JobStatusResponse): BrokerJobDetails {
		return {
			jobId: job.jobId,
			serviceUUID: job.serviceUUID,
			serviceName: job.serviceName,
			serviceVersion: job.serviceVersion,
			status: job.state,
			priority: job.priority,
			deps: job.deps,
			cacheHits: job.cacheHits,
			createdAt: job.createdAt,
			triggeredBy: job.triggeredBy,
			triggeredByDisplayName: job.triggeredByDisplayName,
			dispatchedAt: job.dispatchedAt,
			finishedAt: job.finishedAt,
			workStarted: job.workStarted,
			error: job.error,
			output: job.output,
		};
	},
};
